import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import { useGetYoutubeConfigurationQuery, useGetYouTubeVideoCommentsQuery } from "../../Services/instagram/Instagram";

const YoutubeComments = () => {
  const { videoId } = useParams();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);
  const navigate = useNavigate();

  const { data: youtubeData } = useGetYoutubeConfigurationQuery({});
  const { data: youtubeVideosData } = useGetYouTubeVideoCommentsQuery({ teamId: youtubeData?.results?.[0]?.team, channelId: youtubeData?.results?.[0]?.channel_id, videoId: videoId });


  useEffect(() => {
    if (youtubeVideosData) {
      console.log("youtubeVideosData", youtubeVideosData);
      setComments(youtubeVideosData?.videos?.comments);
      setLoading(false);
    }
  }, [youtubeVideosData]);



  const truncateDescription = (description: string, maxLength: number) => {
    if (description?.length > maxLength) {
      return description.slice(0, maxLength) + "...";
    }
    return description;
  };

  const handleBack = () => {
    navigate("/social-media/youtube");
  };

  if (loading)
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">
            <LoadingSpinner />
          </p>
        </div>
      </div>
    );

  if (error)
    return (
      <div className="flex justify-center items-center h-64 text-red-600 font-medium">
        {error}
      </div>
    );

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
        {/* <IconButton onClick={handleBack}> */}
        <button className="btn btn-link mb-2" onClick={handleBack}>
          <i
            className="bi bi-arrow-90deg-left"
            style={{
              fontSize: "20px",
              color: "black",
              cursor: "pointer",
            }}
          ></i>
        </button>
        {/* </IconButton> */}
        <Typography variant="h6" component="div" sx={{ ml: 1 }}>
          Comments for {videoId}
        </Typography>
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>S.no.</TableCell>
              <TableCell>Author</TableCell>
              <TableCell>Comments</TableCell>
              <TableCell>Likes</TableCell>
              <TableCell>Published date</TableCell>
              <TableCell>Replies</TableCell>
              <TableCell>Likes on replies</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {comments?.length > 0 ? (
              comments?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row?.author}</TableCell>
                  <TableCell sx={{ color: "#666" }} title={row?.text}>
                    {truncateDescription(row?.text, 90)}
                  </TableCell>
                  <TableCell>{row.like_count}</TableCell>
                  <TableCell>{formatDate(row.published_at)}</TableCell>
                  <TableCell>
                    {row?.replies?.length > 0 ? (
                      row?.replies?.map((reply) => (
                        <Box key={reply?.id} sx={{ mb: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ color: "green" }}
                            title={reply?.text}
                          >
                            {truncateDescription(reply?.text, 70)}
                          </Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="error">
                        No Replies
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {row?.replies?.length > 0 ? (
                      row?.replies?.map((reply: any) => (
                        <Box key={reply?.reply_id} sx={{ mb: 1 }}>
                          <Typography variant="body2">
                            {reply?.like_count ?? 0}
                          </Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2">0</Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>
                  <Typography textAlign="center">
                    No comments found for this video.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default YoutubeComments;
